import type { RefObject } from 'react';

import type { Chat } from '@mint-sdk/api-ai-assistant';

import { DataTable } from '../../../../components/index.js';
import { formatLabel } from '../../../../helpers/charts.js';
import type { ContentBlock, ConstructorTableProps } from '../../types.js';
import { RelatedBlockWrapper } from '../related/RelatedBlockWrapper.jsx';

const TableBlock = ({
  block,
  dataframe,
  chatId,
  messageId,
  relatedBlocks,
  blockRefs,
  containerRef,
  type,
  tableComponent,
}: {
  block: ContentBlock;
  dataframe?: Chat.DataframeType;
  chatId: string;
  messageId: string;
  relatedBlocks: ContentBlock[];
  blockRefs: RefObject<Map<string, HTMLDivElement>>;
  containerRef?: RefObject<HTMLDivElement | null>;
  type: 'mobile' | 'agentic' | 'desktop';
  tableComponent?: React.ComponentType<ConstructorTableProps>;
}) => {
  const isVisibleDataTable =
    (dataframe?.length ?? 0) > 0 && Array.isArray(dataframe);

  const tableName = formatLabel(block.varName);

  const TableComponent = tableComponent ?? DataTable;

  return isVisibleDataTable ? (
    <RelatedBlockWrapper
      blockId={block.id}
      blockRefs={blockRefs}
      containerRef={containerRef}
      relatedBlocks={relatedBlocks}
    >
      <TableComponent
        dataframeData={dataframe}
        chatId={chatId}
        tableName={tableName}
        messageId={String(messageId)}
        type={type}
      />
    </RelatedBlockWrapper>
  ) : null;
};

export { TableBlock };
